import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";

export const SignaturePad = forwardRef(function SignaturePad({ onChange, height = 160, testid = "signature-pad" }, ref) {
  const canvas = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const cv = canvas.current;
    const ratio = window.devicePixelRatio || 1;
    cv.width = cv.offsetWidth * ratio;
    cv.height = height * ratio;
    const ctx = cv.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0B1512";
  }, [height]);

  const pos = (e) => { const r = canvas.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); canvas.current.setPointerCapture?.(e.pointerId); drawing.current = true; const ctx = canvas.current.getContext("2d"); const [x, y] = pos(e); ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + 0.1, y + 0.1); ctx.stroke(); };
  const move = (e) => { if (!drawing.current) return; const ctx = canvas.current.getContext("2d"); const [x, y] = pos(e); ctx.lineTo(x, y); ctx.stroke(); };
  const up = () => { if (!drawing.current) return; drawing.current = false; setEmpty(false); onChange?.(false); };
  const clear = () => { const cv = canvas.current; cv.getContext("2d").clearRect(0, 0, cv.width, cv.height); setEmpty(true); onChange?.(true); };

  useImperativeHandle(ref, () => ({ clear, isEmpty: () => empty, toDataURL: () => canvas.current.toDataURL("image/png") }));

  return (
    <canvas ref={canvas} style={{ height, touchAction: "none" }} aria-label="Signature drawing area" data-testid={testid}
      onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
      className="w-full cursor-crosshair rounded-xl border border-dashed border-[#B7C3C7] bg-white" />
  );
});
